import type React from 'react';

import { DesignSystemLegacy } from '@change-corgi/design-system-legacy/core';
import { sunriseTheme } from '@change-corgi/design-system-legacy/theme';

import { PageBody } from '../components/PageBody';
import { PageHeading } from '../components/PageHeading';
import { PageMeta } from '../components/PageMeta';
import { PageTabs } from '../components/PageTabs';

import { useTrackPageView } from './hooks/useTrackPageView';

export const Layout: React.FC = () => {
	useTrackPageView();

	return (
		<DesignSystemLegacy theme={sunriseTheme}>
			<PageMeta />
			<div className="container pb-4">
				<PageHeading />
				<PageTabs />
				<PageBody />
			</div>
		</DesignSystemLegacy>
	);
};
